var mod = function (n, m) {
  return (n % m + m) % m;
};

export default mod;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/mod.js
// module id = 69
// module chunks = 0